export default __webpack_public_path__ + "static/media/No.6-4.351d15a6.jpg";